<template>

    <div class="container bg-none static">

        <div class="row">
            <div class="col-12 col-lg-9 col ideas-size ideas-list">
                <div class="remove">
                    <div class="widgets-ideas">
                        <router-link :to="{ name: 'ideas'}"
                                     class="widgets-ideas-button"
                                     active-class="is-active" exact>
                            На голосовании
                            <span class="counter">{{ counters.total }}</span>
                        </router-link>
                        <router-link :to="{ name: 'inprocess-ideas'}"
                                     class="widgets-ideas-button"
                                     active-class="is-active">
                            В работе
                            <span class="counter">{{ counters.inprocess }}</span>
                        </router-link>
                        <router-link :to="{ name: 'completed-ideas'}"
                                     class="widgets-ideas-button"
                                     active-class="is-active">
                            Реализованные
                            <span class="counter">{{ counters.completed }}</span>
                        </router-link>
                        <router-link v-if="isLogged"
                                     :to="{ name: 'my-ideas'}"
                                     class="widgets-ideas-button"
                                     active-class="is-active">
                            Мои идеи
                            <span class="counter">{{ counters.my }}</span>
                        </router-link>
                        <router-link v-if="isLogged"
                                     :to="{ name: 'starred-ideas'}"
                                     class="widgets-ideas-button"
                                     active-class="is-active">
                            Избранные
                            <span class="counter">{{ counters.starred }}</span>
                        </router-link>
                    </div>
                </div>

                <div class="clearfix menu-forms">
                    <ul class="menu-ideas">
                        <li :class="{
                                'ideas-news': true,
                                'active': !currentSort || currentSort == 'new'
                            }">
                            <button @click="setSort('new')">Новые</button>
                        </li>
                        <li :class="{
                                'ideas-popular': true,
                                'active': currentSort == 'popular'
                            }">
                            <button @click="setSort('popular')">Популярные</button>
                        </li>
                    </ul>
                </div>

                <Idea v-for="idea in ideas"
                      :key="idea.id"
                      :idea="idea" />
                <button v-if="currentPage < totalPages"
                        class="button block more"
                        @click="loadIdeas(currentPage + 1)">
                    Показать ещё
                </button>

                <router-view></router-view>

            </div>

            <div class="col-12 col-lg-3 mobile-menu-ideas">
                <div class="menu-admin" v-if="isAdmin">
                    <router-link :to="{ name: 'canceled-ideas'}"
                             tag="div"
                             class="widgets-ideas-button"
                             active-class="is-active">
                        Отклонённые
                        <span class="counter">{{ counters.canceled }}</span>
                    </router-link>
                    <router-link :to="{ name: 'moderation-ideas'}"
                                 tag="div"
                                 class="widgets-ideas-button"
                                 active-class="is-active">
                        На модерации
                        <span class="counter">{{ counters.moderation }}</span>
                    </router-link>
                </div>
                <div class="filter-category">
                    <div class="mobile-close">
                        <h2 class="title-filter">
                            Фильтр по категориям<span class="close-menu-form">&times;</span>
                        </h2>
                    </div>
                    <ul class="filter-menu">

                        <li class="filter-item all-select"
                            :class="{ 'active-item': isCatFilterEmpty()}"
                            @click="setCategory()">
                            <span class="icon-form"></span>Все
                        </li>

                        <li class="filter-item"
                            v-for="cat in rootCategories"
                            :class="{ 'active-item': isCatSelected(cat.id)}"
                            @click="toggleCategory(cat)">
                            <span class="icon-form"></span>
                            {{ cat.title }}
                            {{ counters.categories ? ` - ${counters.categories[cat.id] || 0}` : '' }}

                            <ul class="sec-menu" v-if="categories[cat.id]">

                                <li class="filter-item"
                                    v-for="child in categories[cat.id]"
                                    :class="{ 'active-item': isCatSelected(child.id)}"
                                    @click="toggleCategory(child)">
                                    <span class="icon-form"></span>
                                    {{ counters.categories ? ` - ${counters.categories[cat.id] || 0}` : '' }}
                                </li>


                            </ul>

                        </li>


                    </ul>

                    <p class="button-us">Применить</p>

                </div>

            </div>
        </div>

    </div>

</template>

<script>
    import {mapState, mapActions} from "vuex"
    import IdeaComponent from "./Idea"

    export default {
        name: 'ideas',
        computed: {

            isAdmin() {
                return this.$store.getters['auth/isAdmin'];
            },

            isLogged() {
                return this.$store.getters['auth/isLogged'];
            },

            counters() {
                return this.$store.state.ideas.counters;
            },

            ideas() {
                return this.$store.state.ideas.ideas
            },

            rootCategories() {
                return this.$store.state.ideas.rootCategories
            },

            categories() {
                return this.$store.state.ideas.categoriesByParentId
            },

            selectedCategories() {
                return this.$store.state.ideas.selectedCategories
            },

            currentSort() {
                return this.$store.state.ideas.query.sort;
            },

            currentPage() {
                return this.$store.state.ideas.currentPage
            },

            totalPages() {
                return this.$store.state.ideas.totalPages
            }
        },

        methods: {

            loadIdeas(page = 1) {
                this.$store.dispatch('ideas/loadIdeas', page);
            },

            setSort(sort) {
                this.$store.dispatch('ideas/setSort', sort);
            },

            toggleCategory(category) {
                this.$store.dispatch('ideas/queryToggleCategory', category.id)
            },

            setCategory(categoryId) {
                this.$store.dispatch('ideas/querySetCategory', categoryId)
            },

            isCatFilterEmpty() {
                return !(this.$store.state.ideas.query.categories.length > 0);
            },

            isCatSelected(categoryId) {
                return !!~this.$store.state.ideas.query.categories.indexOf(categoryId);
            },

            reload() {
                this.$store.commit('ideas/SET_QUERY', {
                    filter: this.$route.meta.filter,
                    sort: this.$route.meta.sortBy || null,
                    categories: this.$route.params.category_id
                        ? [this.$route.params.category_id]
                        : this.selectedCategories
                });
                this.$store.dispatch('ideas/loadIdeas');
            }
        },

        watch: {
            '$route' (to, from) {
                this.reload();
            }
        },

        mounted() {
            if (this.ideas.length > 0) {
                this.$store.commit('ideas/SET_IDEAS', []);
            }
            this.reload();
        },

        components: {
            'Idea': IdeaComponent
        }

    }
</script>


// WEBPACK FOOTER //
// Ideas.vue?d040e4d0